import React, { FC } from 'react';

import { Table } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { NSKeys } from '@app/i18n';
import { isForbiddenError } from '@app/services/apiErrors';
import { useTableParams } from '@app/services/hooks/useTableParams';
import { AccessDenied } from '@components/AccessDenied';
import { Paper } from '@components/Paper';
import { TABS } from '@pages/Warehouses/pages/Single/interfaces';

import { WarehouseActions } from '../../../../components/WarehouseActions';
import { useGetWarehousesQuery } from '../../../../hooks';
import { getWarehouseColumns } from '../../constants';

export const CustomerWarehouses: FC = () => {
  const navigate = useNavigate();
  const warehousesT = useTranslation(NSKeys.warehouses);
  const commonT = useTranslation(NSKeys.common);
  const { current, pageSize, setPagination } = useTableParams();
  const { data, isLoading, error } = useGetWarehousesQuery({
    offset: (current - 1) * pageSize,
    limit: pageSize,
  });

  if (isForbiddenError(error)) {
    return <AccessDenied />;
  }

  return (
    <Paper style={{ margin: '24px', padding: '16px 24px 0 24px' }}>
      <Table
        dataSource={data?.items}
        rowKey="uid"
        className="tableClassname"
        columns={[
          ...getWarehouseColumns({ isProvider: false, t: warehousesT.t }),
          {
            key: 'action',
            align: 'right',
            render: (_, record) => <WarehouseActions warehouse={record} />,
          },
        ]}
        rowClassName="cursorPointer"
        style={{ overflow: 'auto' }}
        onRow={(row) => {
          return {
            onClick: () => !!row?.$permissions?.view && navigate(`${row.uid}/${TABS.SETTINGS}`),
          };
        }}
        loading={isLoading}
        scroll={{ x: true }}
        pagination={{
          current: current,
          pageSize: pageSize,
          total: data?.total,
          showQuickJumper: true,
          showSizeChanger: true,
          position: ['bottomCenter'],
          onChange: (newPage, newSize) => {
            setPagination(newPage, newSize);
          },
          showTotal: (total, range) => `${range[0]}-${range[1]} ${commonT.t('paginationOf')} ${total}`,
        }}
      />
    </Paper>
  );
};
